/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Macro_ProteinInputs */

const en_platform_macro_protein = /** @type {(inputs: Platform_Macro_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein`)
};

const pl_platform_macro_protein = /** @type {(inputs: Platform_Macro_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Białko`)
};

/**
* | output |
* | --- |
* | "Protein" |
*
* @param {Platform_Macro_ProteinInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_macro_protein = /** @type {((inputs?: Platform_Macro_ProteinInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Macro_ProteinInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_macro_protein(inputs)
	return en_platform_macro_protein(inputs)
});